import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'

export default function N25_10_08() {
  return (
    <NoteContainer date={'08/10/2025'} version="20.9.0">
      <VStack w="full">
        <ModuleContainer moduleName="ASSESSMENTS_AND_RESEARCH">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>
                  Perfil com páginas completas e voltadas para o locais vinculados do usuário
                </TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa</TaskBreadcrumb>
                <TaskDescription>
                  Agora, existem permissões especificas para cada página do perfil da pesquisa
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Questões deletadas são apresentadas na interface</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa/ Relatórios</TaskBreadcrumb>
                <TaskDescription>
                  Agora, no gáfico de pontuação por questão, irá aparecer um ícone vermelho indicado que aquela questão
                  foi excluída do formulário, informando a data e hora da exclusão.
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Visualizações de relatórios independentes</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa/ Relatórios</TaskBreadcrumb>
                <TaskDescription>
                  Agora, cada visualização possui um carregamento próprio, não é necessário finalizar todos os
                  carregamentos para poder visualizar a página
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Ajustes no responsivo</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Perfil da pesquisa/ Relatórios</TaskBreadcrumb>
                <TaskDescription>Tratamento no responsivo para telas menores.</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
